require('./bootstrap');
require('../../node_modules/moment');

import I18n from './vendor/I18n';

window.I18n = I18n;

import makeAlert from './helpers/makeAlert';

window.makeAlert = makeAlert;

import getUrlParameter from './helpers/getUrlParameter';

window.getUrlParameter = getUrlParameter;

const flare = require("@flareapp/js").flare;

if (window.location.hostname === 'postra.prowledge.com') {
    flare.light();

    // Exposed globally so page-specific bundles (separate webpack entry points, e.g.
    // Reporting/project_reporting/index.js) can report to the same initialized client
    // instead of pulling in an unconfigured copy of @flareapp/js.
    window.flare = flare;

	const addUserContext = () => {
		if (window?.auth?.user_id) {
			flare.addContext("user", {
				id: window.auth.user_id,
				name: window.auth.user_name || null
			});
		} else {
			setTimeout(addUserContext, 5000);
		}
	};
	addUserContext();
}

window.bootbox = require('bootbox');
window.confirmGoBack = function (elm) {
    event.preventDefault();
    bootbox.confirm({
        message: "Haluatko varmasti palata? Muutoksesi eivät tallennu.",
        buttons: {
            confirm: {
                label: 'Kyllä',
                className: 'btn-success'
            },
            cancel: {
                label: 'Ei',
                className: 'btn-danger'
            }
        },
        callback: function (result) {
            if (result) {
                window.location.assign(elm.href);
            }
        }
    });
};

window.view = {};